import React, {useState} from "react";
import style from "./contactform.module.scss";
import {ContactusForm} from "../../../utils/api";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import {withRouter} from "react-router-dom";
import CoverImage from "../../../assets/cover3d.png";
import logoimage from "../../../assets/logo_without-tagline.png";

function Contactform({history}) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
  });
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    history.push("/");
  };

  const handleChange = (e) => {
    const {name, value} = e.target;
    let error = "";
    switch (name) {
      case "name":
        error = value.trim() && value.length > 2 ? "" : "Name is required";
        break;
      case "email":
        error = value.trim()
          ? /^\S+@\S+\.\S+$/.test(value)
            ? ""
            : "Email is invalid"
          : "Email is required";
        break;
      case "mobile":
        if (!/^\d*$/.test(value)) {
          return;
        }
        error =
          value.trim().length > 7 && value.trim().length < 16
            ? ""
            : "Please enter valid mobile number";
        break;
      default:
        break;
    }

    setFormData({
      ...formData,
      [name]: value,
    });

    setErrors({
      ...errors,
      [name]: error,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = {};
    if (!formData.name.trim()) {
      errors.name = "Name is required";
    }
    if (!formData.email.trim()) {
      errors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      errors.email = "Email is invalid";
    }
    if (!formData.mobile.trim()) {
      errors.mobile = "Mobile number is required";
    } else if (
      !(formData.mobile.trim().length > 7 && formData.mobile.trim().length < 16)
    ) {
      errors.mobile = "Please enter valid mobile number";
    }
    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      console.log("Form submitted:", formData);

      ContactusForm({
        firstName: formData.name,
        email: formData.email,
        phoneNo: formData.mobile,
        content: "",
      })
        .then((res) => {
          console.log("response--", res);
          if (res?.status == 200) {
            setShow(true);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <div className={style.advice_menu}>
      <div className={style.main_heading}>
        <h2 className={style.heading}>
          Uncover the 11 'Hiring Trends' that could 2X your bottom line in 12 months,
          hedge 100% injury cover claims for 6 months & reduce staff churn
          'HEADACHES' by 19%.
        </h2>
      </div>
      <div className={style.heading_sec}>
        <p className={style.sub_heading}>
          BYE-BYE Tyre Kickers, Time Wasters, Expensive on-boarders, and DISCOVER how
          Top Companies are changing their landscape & crushing their Operational
          Productivity demands.
        </p>
      </div>
      {/* <div className={style.cover_images}>
        <img src={CoverImage} className={style.image_cover} />
        </div>  
        <div className={style.form_sub}>
          <form onSubmit={handleSubmit}>
            <div className={style.form_group}>
              <label className={style.label}>Name:</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={style.input_field}
                autoComplete="off"
              />
              {errors.name && (
                <span className={style.error_message}>{errors.name}</span>
              )}
            </div>
            <div className={style.form_group}>
              <label className={style.label}>Email:</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={style.input_field}
                autoComplete="off"
              />
              {errors.email && (
                <span className={style.error_message}>{errors.email}</span>
              )}
            </div>
            <div className={style.form_group}>
              <label className={style.label}>Mobile Number:</label>
              <input
                type="text"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                className={style.input_field}
                autoComplete="off"
              />
              {errors.mobile && (
                <span className={style.error_message}>{errors.mobile}</span>
              )}
            </div>
            <button type="submit" className={style.submit_button}>
              Submit
            </button>
          </form>
        </div>    */}
      <div className={style.advice_container}>
        <div className={style.cover_image}>
          <img src={CoverImage} className={style.image_cover} />
        </div>
        <div className={style.form_sub}>
          <form onSubmit={handleSubmit} className={style.form_inputs}>
            <div className={style.form_group}>
              <h5 className={style.form_title}>
                Please fill in your details to have this ‘BANGER’ 2024 Report sent
                directly to your email inbox:
              </h5>
              <label className={style.label}>Name:</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={style.input_field}
                autoComplete="off"
              />
              {errors.name && (
                <span className={style.error_message}>{errors.name}</span>
              )}
            </div>
            <div className={style.form_group}>
              <label className={style.label}>Email:</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={style.input_field}
                autoComplete="off"
              />
              {errors.email && (
                <span className={style.error_message}>{errors.email}</span>
              )}
            </div>
            <div className={style.form_group}>
              <label className={style.label}>Mobile Number:</label>
              <input
                type="text"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                className={style.input_field}
                autoComplete="off"
              />
              {errors.mobile && (
                <span className={style.error_message}>{errors.mobile}</span>
              )}
            </div>
            <button type="submit" className={style.submit_button}>
              Submit
            </button>
          </form>
        </div>
      </div>

      <div className={style.heading_sec}>
        <p className={style.sub_heading2}>
          The Labour Market has changed. Now we have no choice but to INNOVATE if we
          are to thrive for many years to come
        </p>
      </div>

      <Modal show={show} className={style.modal_outer} onHide={handleClose} centered>
       
        <Modal.Body className="px-4 pt-5 modal_body">
         <div>
         <img src={logoimage} className={style.logo_image} />
          <p className={style.thank_msj}>
            you made it… your decision to get this report just gave you an unfair
            advantage. Thanks for trusting us with your info. Your free report is on
            the way, we will get that over to you shortly Have a great day!
          </p>
         </div>
          {/* <div className={style.footer_text}>
            <p>
              I’m Matt.
              <br />
              I compiled the data,
              <br />
              Wrote the report,
              <br />
              Convinced my boss to give to you for free,
              <br />
              And I will be prioritising your business needs.
            </p>
            <p>
              I personally, will meet with you,
              <br />
              Create a dream candidate avatar with you,
              <br />
              Understand your business,
              <br />
              Offer you my ‘Matt Madness’ discount structure,
              <br />
              Ensure ‘Va-Va Zoom’ speedy placements,
            </p>
            <p>
              And ultimately treat you like my family’s well-being depended on it,
              Because it does.
            </p>
            <p>
              As a South African immigrant and brand new to the country, I am only
              too eager to bring you success, Which in turn creates stability for my
              wife and daughters.
            </p>
            <p>
              Enjoy the report.
              <br />
              Speak with you soon.
            </p>
          </div> */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Back
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default withRouter(Contactform);
